export default __webpack_public_path__ + "static/media/icon_page_checklist_white.f3ae82a3.svg";